import { defineStore } from 'pinia';
import { cloneDeep, get, each, find, map } from 'lodash';
import Vue from 'vue';

import CurrencyManagementApi from '@/extensions/shop/store/api/currencyManagement';

export const useShopCurrencyStore = defineStore('shopCurrency', {
    state: () => ({
        loading: true,
        currenciesPaginated: {
            path: null,
            variables: {
                paginationSizes: [25, 50, 100],
            },
            filters: {},
            pageInfo: {
                total: 0,
                perPage: 25,
                currentPage: 1,
                lastPage: 0,
            },
            allColumns: [],
            activeColumns: [],
            showFilters: false,
            link: {},
            defaultSort: null,
            items: [],
        },
        availableCurrencies: [],
    }),

    actions: {
        addPaginatedCurrenciesToState(data) {
            this.currenciesPaginated.items = data.items;
            this.currenciesPaginated.pageInfo = cloneDeep(data.pageInfo);
            this.currenciesPaginated.allColumns = cloneDeep(data.config.allColumns);
            this.currenciesPaginated.link = cloneDeep(get(data.config, 'link') || {});
            this.currenciesPaginated.defaultSort = get(data.config, 'defaultSort') || null;
            this.currenciesPaginated.showFilters = get(data.config, 'showFilters') || false;
        },

        defineActiveColumns(activeColumnKeys) {
            const activeColumns = [];
            each(this.currenciesPaginated.allColumns, (column) => {
                const allowed = find(activeColumnKeys, (value) => column.key === value);
                if (allowed) activeColumns.push(column);
            });

            if (activeColumns.length) {
                this.currenciesPaginated.activeColumns = activeColumns;
            }
        },

        defineItemsPerPage(perPage) {
            this.currenciesPaginated.pageInfo.perPage = perPage;
        },

        defineCurrentPage(currentPage) {
            this.currenciesPaginated.pageInfo.currentPage = currentPage;
        },

        defineFilterValue({ key, value }) {
            if (
                value.match === '' &&
                value.like === '' &&
                value.from === '' &&
                value.to === '' &&
                value.in.length === 0
            ) {
                Vue.delete(this.currenciesPaginated.filters, key);
            } else {
                Vue.set(this.currenciesPaginated.filters, key, value);
            }
        },

        defineFilterVisibility(value) {
            Vue.set(this.currenciesPaginated, 'showFilters', value);
        },

        defineSorting({ key, value }) {
            Vue.set(this.currenciesPaginated.variables, 'order', key);
            Vue.set(this.currenciesPaginated.variables, 'direction', value);
        },

        updateLoading(value) {
            this.loading = value;
        },

        setAvailableCurrencies(currencies) {
            Vue.set(this, 'availableCurrencies', currencies);
        },

        fetchCurrenciesPaginated() {
            return CurrencyManagementApi.fetchCurrenciesPaginated(this.currenciesPaginated).then((data) => {
                this.addPaginatedCurrenciesToState(data);

                const activeColumnKeys = map(data.config.activeColumnKeys, 'key');
                this.defineActiveColumns(activeColumnKeys);
            });
        },

        fetchAvailableCurrencies(cmsId = null) {
            return CurrencyManagementApi.fetchAllForShop(cmsId).then((currencies) => {
                this.setAvailableCurrencies(currencies);
                return currencies;
            });
        },

        save(currency, shopId = null) {
            return CurrencyManagementApi.save(currency, shopId);
        },

        delete(id) {
            return CurrencyManagementApi.delete(id);
        },
    },
});
